import { useState, useEffect, useCallback } from 'react';
import { getBalance } from './billingApi';

export default function useBillingBalance(apiBase) {
  const [balance, setBalance] = useState(null);
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [loading, setLoading] = useState(true);
  const [accountInfo, setAccountInfo] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    const result = await getBalance(apiBase);
    if (result.ok) {
      setBalance(result.data.balance ?? 0);
      setIsUnlimited(result.data.is_unlimited ?? false);
      setAccountInfo(result.data);
    }
    setLoading(false);
  }, [apiBase]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { balance, isUnlimited, loading, refresh, accountInfo };
}
